module.exports = __webpack_public_path__ + "static/media/indoor-air.a5b3c6f5.svg";